import { vOnClickOutside } from '@vueuse/components'
import { createApp } from 'vue'
import VueSafeTeleport from 'vue-safe-teleport'

import pinia from '@/store/index'

import App from './App.vue'
import router from './router'
/*
Importing whole echarts to fix code splitting issue.
They encourage to import one by one for each use case instead of this mass import.
https://github.com/ecomfe/vue-echarts#readme
*/
import 'echarts'

import VueGoogleMaps from 'vue-google-maps-community-fork'

import { ConsoleTracker, InternalTracker, MultiTracker, trackerPlugin } from '@last/core-ui/paprika'
import { LDialogPlugin } from '@last/core-ui/paprika/plugins/dialog'
import eventSender from '@last/core-ui/scripts/eventSender'
import LNotificationPlugin from '@last/core-ui/v3/plugins/notification'

import { useAuthStore } from '@/store/auth'

import { createFilters } from './filters'
import i18n from './i18n'

import './style.css'

const filters = createFilters(pinia)

const app = createApp({ name: 'LastAdmin', ...App })

let trackers = []

if (import.meta.env.VITE_NODE_ENV === 'development') {
  trackers.push(new ConsoleTracker())
}

trackers.push(new InternalTracker(import.meta.env.VITE_API_BASE_URL))

// Create a single tracker instance and expose it globally to avoid inject() usage outside setup
const trackerInstance = new MultiTracker(trackers)
window.__LAST_TRACKER__ = trackerInstance
app.use(trackerPlugin, {
  tracker: trackerInstance
})

app.use(LDialogPlugin)
app.use(LNotificationPlugin)
app.use(pinia)
app.use(i18n)
app.use(router)
app.use(VueGoogleMaps, {
  load: {
    key: import.meta.env.VITE_GOOGLE_KEY,
    libraries: 'places,drawing,visualization',
    loading: 'async',
    language: 'en-US'
  },
  installComponents: true
})
app.use(VueSafeTeleport)

app.config.globalProperties.$filters = filters
app.provide('filters', filters)
app.directive('click-outside', vOnClickOutside)

app.mount('#app')

const {
  VITE_GOOGLE_ANALYTICS_ID,
  VITE_FACEBOOK_ANALYTICS_ID,
  VITE_META_CONVERSION_API_TOKEN,
  VITE_MICROSOFT_ADS_ID
} = import.meta.env

eventSender.load(
  {
    googleAnalyticsId: VITE_GOOGLE_ANALYTICS_ID,
    facebookAnalyticsId: VITE_FACEBOOK_ANALYTICS_ID,
    metaConversionApiToken: VITE_META_CONVERSION_API_TOKEN,
    microsoftAdsId: VITE_MICROSOFT_ADS_ID,
    domains: ['last.app', 'admin.last.app']
  },
  router,
  () => {
    const authStore = useAuthStore()
    return authStore.rootUser
  }
)
